module.exports = __webpack_public_path__ + "img/A1972.c1b8b78e.png";